import { Download } from "lucide-react";

export default function CommissionFilters({
  filterStatus, setFilterStatus,
  filterProduct, setFilterProduct,
  filterBroker, setFilterBroker,
  canFilterBroker, brokers,
  onExport, exporting,
  totalCount, setPage,
}) {
  var brokerOptions = [];
  if (canFilterBroker && brokers) {
    for (var i = 0; i < brokers.length; i++) {
      brokerOptions.push(
        <option key={brokers[i].id} value={brokers[i].id}>{brokers[i].name}</option>
      );
    }
  }

  return (
    <div className="bg-white rounded-xl lg:rounded-2xl p-4 shadow-sm mb-4">
      <div className="flex flex-col sm:flex-row gap-3">
        <div className="flex gap-2 flex-1 flex-wrap">
          <select value={filterStatus} onChange={function(e) { setFilterStatus(e.target.value); setPage(1); }}
            className="px-3 py-2.5 bg-gray-50 border border-gray-100 rounded-xl text-sm bg-white" data-testid="commission-filter-status">
            <option value="">Todos os Status</option>
            <option value="pendente">Pendente</option>
            <option value="processando">Processando</option>
            <option value="pago">Pago</option>
            <option value="travada">Travada</option>
          </select>
          <select value={filterProduct} onChange={function(e) { setFilterProduct(e.target.value); setPage(1); }}
            className="px-3 py-2.5 bg-gray-50 border border-gray-100 rounded-xl text-sm bg-white" data-testid="commission-filter-product">
            <option value="">Todos os Produtos</option>
            <option value="consorcio">Consorcio</option>
            <option value="seguro">Seguro</option>
            <option value="carta_contemplada">Carta Contemplada</option>
          </select>
          {canFilterBroker && (
            <select value={filterBroker} onChange={function(e) { setFilterBroker(e.target.value); setPage(1); }}
              className="px-3 py-2.5 bg-gray-50 border border-gray-100 rounded-xl text-sm bg-white" data-testid="commission-filter-broker">
              <option value="">Todos os Corretores</option>
              {brokerOptions}
            </select>
          )}
        </div>
        <div className="flex items-center gap-2">
          <button onClick={onExport} disabled={exporting}
            className="flex items-center gap-1.5 px-3 py-2.5 border border-gray-200 rounded-xl text-xs font-medium text-gray-600 hover:bg-gray-50 disabled:opacity-50 whitespace-nowrap"
            data-testid="commission-export-btn">
            <Download className="w-3.5 h-3.5" />{exporting ? "Exportando..." : "Exportar Excel"}
          </button>
          <span className="text-xs text-gray-400" data-testid="commission-total-count">{totalCount} registro{totalCount !== 1 ? "s" : ""}</span>
        </div>
      </div>
    </div>
  );
}
